module.exports = __webpack_public_path__ + "img/active_j.3a3a86ea.png";